import { render } from "./do-not-assume.vue?vue&type=template&id=26c76720&scoped=true&ts=true"
import script from "./do-not-assume.vue?vue&type=script&lang=ts"
export * from "./do-not-assume.vue?vue&type=script&lang=ts"

import "./do-not-assume.vue?vue&type=style&index=0&id=26c76720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c76720"]])

export default __exports__